import { render, staticRenderFns } from "./TheCrossIcon.vue?vue&type=template&id=4eb5a556&scoped=true&"
import script from "./TheCrossIcon.vue?vue&type=script&lang=js&"
export * from "./TheCrossIcon.vue?vue&type=script&lang=js&"
import style0 from "./TheCrossIcon.vue?vue&type=style&index=0&id=4eb5a556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5a556",
  null
  
)

export default component.exports